module.exports = {
    "source_code": "HLXEMS",
    "site_id": "explore.wcupa.edu",
    "title": "West Chester University",
    "tfn": "",
    "url": "https://explore.wcupa.edu",
    "gtm_code": "GTM-TCSQGCJ",
}